import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    redColor: {
      color: theme.palette.error.main,
    },
  })
);
